import { icon, node } from "~/util/dom";

interface IFilterButtonProps {
	checked?: boolean;
	label: Node | HTMLElement;
	value: string;
	type: string;
}

export function createFilterButton({
	checked = false,
	label,
	value,
	type,
}: IFilterButtonProps) {
	const labelElement = node("label", { className: "ui-filter-button" });
	const input = node("input", { type: "checkbox", value });

	labelElement.appendChild(label);

	input.dataset.type = type;

	labelElement.firstChild.before(input);
	labelElement.appendChild(icon("filter-clear"));

	if (checked) {
		input.checked = true;
		labelElement.classList.add("ui-filter-button--active");
	}

	labelElement.addEventListener("change", function onChange() {
		labelElement.classList.toggle("ui-filter-button--active");
	});

	return labelElement;
}
